// src/components/NetBillTermsAndConditions.jsx
import React from 'react';
import LegalDocPage from './LegalDocPage';

const NetBillTermsAndConditions = () => <LegalDocPage docType="terms" />;

export default NetBillTermsAndConditions;
